
// vue
import { defineComponent, h } from 'vue';

// functions
import { generateHTML, getSlotsMsgBody } from '@/functions/atoms/ChatMsgBody';

export default defineComponent({
  props: {
    postUser: {
      type: String,
      require: false,
      default: 'student',
    },
  },
  setup(props, { slots }) {
    // デフォルトスロットで渡ってきた本文を取得
    const msgBody = getSlotsMsgBody(slots);
    if (msgBody === -1) {
      return () => h('p', ['メッセージの変換に失敗しました']);
    }

    // msgBody内の特殊記法をHTMLタグに変換した配列を作成
    const htmlList = generateHTML(msgBody);

    const className = `msg-body ${props.postUser}`;

    return () => h('p', { class: className }, htmlList);
  },
});
